import React from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { CheckCircle, Sparkles } from 'lucide-react';

const SuccessModal = ({ open, onClose }) => {
  const travelQuotes = [
    "Adventure awaits! Your journey begins now.",
    "The world is yours to explore. Let's make it happen!",
    "Pack your bags, unforgettable memories are on the way!",
    "Your dream destination is just a step away.",
    "Get ready for the adventure of a lifetime!",
    "New horizons are calling. Time to answer!",
    "Life is short, the world is wide. Let's explore it together!",
  ];

  const randomQuote = travelQuotes[Math.floor(Math.random() * travelQuotes.length)];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <div className="text-center space-y-6 py-6">
          {/* Animated Success Icon */}
          <div className="relative flex justify-center">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-24 h-24 bg-green-100 rounded-full animate-ping"></div>
            </div>
            <div className="relative bg-green-500 rounded-full p-4 animate-bounce">
              <CheckCircle className="w-12 h-12 text-white" />
            </div>
          </div>

          {/* Success Message */}
          <div className="space-y-3">
            <h2 className="text-2xl font-bold text-gray-900 flex items-center justify-center gap-2">
              <Sparkles className="w-6 h-6 text-amber-500" />
              Inquiry Sent Successfully!
              <Sparkles className="w-6 h-6 text-amber-500" />
            </h2>
            <p className="text-gray-600">
              Thank you for reaching out! Our team will contact you shortly.
            </p>
          </div>

          {/* Travel Quote */}
          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg">
            <p className="text-amber-900 font-medium italic text-lg">
              "{randomQuote}"
            </p>
          </div>

          {/* Confetti Effect */}
          <div className="flex justify-center gap-2 animate-bounce">
            {['🎉', '✈️', '🌍', '🎊', '⛰️'].map((emoji, idx) => (
              <span
                key={idx}
                className="text-3xl animate-pulse"
                style={{ animationDelay: `${idx * 0.2}s` }}
              >
                {emoji}
              </span>
            ))}
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            Start Planning Your Adventure
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
